import AvatarBuilder from "./AvatarBuilder";
import ColorPicker from "./ColorPicker";

export default {
  AvatarBuilder,
  ColorPicker
};
